import { NgModule } from '@angular/core';
import { CxDatePipe } from '@spartacus/core';
import { TIME_SLOTS_NORMALIZER, TimeSlotsNormalizer } from './converters';

@NgModule({
  providers: [
    CxDatePipe,
    {
      provide: TIME_SLOTS_NORMALIZER,
      useClass: TimeSlotsNormalizer,
      multi: true,
    },
  ],
})
export class CheckoutDataAccessEagerModule {}
